import React from "react"
import { DatoContentBaseProps } from "../../types"
import FeaturedCardWithText from "@components/FeaturedCardWithText"

interface DatoCmsComponentFeaturedCardWithTextProps
  extends DatoContentBaseProps {}

const stripHash = (value?: string) =>
  value?.startsWith("#") ? value.slice(1) : value

const plainTextFromStructured = (value?: { value?: any }) => {
  const document = value?.value?.document
  if (!document) return undefined
  let result = ""
  const walk = (node: any) => {
    if (!node) return
    if (node.type === "span" && typeof node.value === "string") {
      result += node.value
      return
    }
    if (Array.isArray(node.children)) {
      node.children.forEach(walk)
      if (node.type === "paragraph") result += "\n"
    }
  }
  walk(document)
  return result.trim() || undefined
}

const formatCard = (card: any = {}) => ({
  id: card?.id,
  cardImage: card?.cardImage?.responsiveImage,
  cardImageSrc: card?.cardImage?.url,
  cardTitle: card?.cardTitle,
  cardTitleColor: stripHash(card?.cardTitleColor?.hex),
  description: card?.description,
  upperSubtitleText: card?.upperSubtitleText,
  upperSubtitleColor: stripHash(card?.upperSubtitleColor?.hex),
  lowerSubtitleText: card?.lowerSubtitleText,
  lowerSubtitleColor: stripHash(card?.lowerSubtitleColor?.hex),
  cardLink: card?.cardLink,
})

const DatoCmsComponentFeaturedCardWithText: React.FC<
  DatoCmsComponentFeaturedCardWithTextProps
> = ({
  sectionTitle,
  buttonText,
  buttonTextColor,
  buttonBackgroundColor,
  textBlock,
  textBlockColor,
  featuredCardWithText,
}) => {
  return (
    <FeaturedCardWithText
      sectionTitle={sectionTitle}
      buttonText={buttonText}
      buttonTextColor={stripHash(buttonTextColor?.hex)}
      buttonBackgroundColor={stripHash(buttonBackgroundColor?.hex)}
      textBlock={plainTextFromStructured(textBlock) || textBlock}
      textBlockColor={stripHash(textBlockColor?.hex)}
      cards={(featuredCardWithText || []).map(formatCard)}
    />
  )
}

export default DatoCmsComponentFeaturedCardWithText
